/** Program slug for the menopause emotional support program. Used for redirects and inline block. */
export const MENOPAUSE_PROGRAM_SLUG = 'menopause-emotional-support-program'
export const MENOPAUSE_ONBOARDING_SLUG = 'menopause'
export const FERTILITY_ONBOARDING_SLUG = 'fertility'
export const FERTILITY_PROGRAM_SLUG = 'fertility-consultation'

/** Program slugs aggregated on the pregnancy consultation hub (upcoming / past). */
export const PREGNANCY_HUB_PROGRAM_SLUGS: readonly string[] = [
  'pregnancy-support',
  'pregnancy-emotional-support-program',
  'pregnancy-ask-a-midwife',
]

/** Program slugs aggregated on the postpartum consultation hub (upcoming / past). */
export const POSTPARTUM_HUB_PROGRAM_SLUGS: readonly string[] = [
  'postpartum-support',
  'postpartum-emotional-support-program',
  'postpartum-ask-a-midwife',
]
